import React from 'react';
import { styled, fluidRange, colors, breakpoints } from '~/styles';
import Modal from 'react-bootstrap/Modal'; // https://react-bootstrap.github.io/components/modal/


export const ModalContainer = styled.div`
  width: 100%;

  .modal-body {
    padding-bottom: 110px;

    video, img {
      /* well, that's not a perfect solution 
        but good enough for now :) */
      max-height: 60vh;
    }
  }  

  .modal-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 27px;
    ${fluidRange('paddingRight', '20px', '67px')};
    padding-bottom: 27px;
    ${fluidRange('paddingLeft', '20px', '67px')};
    box-sizing: border-box;

    @media (max-height: 768px) {
      padding-top: 18px;
      padding-bottom: 18px;
    }

    .footer-container {
      display: flex;
      .footer-container-left {
        flex-grow: 1;
        .resource-title {
          font-size: 29.5px;
          font-weight: bold;
          margin-bottom: 12px;
          ${fluidRange('fontSize', '16px', '24px', breakpoints.xs, breakpoints.xl)};
          @media (max-height: 768px) {
            font-size: 16px;
          }
        }
        .resource-description {
          font-size: 21.5px;
          ${fluidRange('fontSize', '14px', '20px', breakpoints.xs, breakpoints.xl)};
          @media (max-height: 768px) {
            font-size: 14px;
          }
        }
      }
      .footer-container-right {
        display: flex;
        justify-content: flex-end;
      }
    }
  }


  &.resource-modal-type--Presentation, 
  &.resource-modal-type--Document {
    .modal-footer {
      background-color: ${colors.white};
    }
  }

  .modal-mode--minimal & {
    .modal-body {
      text-align: center;
      padding-bottom: 2em;
    }
    .footer-container {
      justify-content: center;
    }

    button + button {
      padding-left: 0;
    }
  }
`


export const ModalBody = Modal.Body;

export const ModalFooter: React.FC = ({ children }) => (
  <Modal.Footer>
    <div className='footer-container'>
      { children }
    </div>
  </Modal.Footer>
);


// WEBPACK FOOTER //
// ./src/components/modals/ResourceModalCommon.tsx